class NSSCarousel extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.swiper;
    this.settings;

    this.videoSlideEls = this.querySelectorAll(`[nss-video-playing]`);
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Carousel] Connected.");

    this.initCarousel();

    this.addEventListener(`click`, this.handleClick.bind(this));

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ];
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  handleClick(e) {
    if (e.target.parentElement.hasAttribute(`nss-control-start`)) {
      this.swiper.slideTo(0);
    }

    if (e.target.parentElement.hasAttribute(`nss-control-end`)) {
      let count = this.swiper.slides.length;
      this.swiper.slideTo(count - 1);
    }

    if (e.target.hasAttribute(`nss-video-playing`)) {
      if (this.debug) console.log("[NSS][Carousel] Clicked video!");
      if (e.target.getAttribute(`nss-video-playing`) === "false") {
        if (this.debug) console.log("[NSS][Carousel] Playing video!");
        this.stopAllVideos();
        e.target.setAttribute(`nss-video-playing`, true);
        const videoEl = e.target.querySelector(`video`);
        videoEl.volume = 0.2;
        videoEl.muted = false;
        videoEl.play();
        if (typeof this.settings.autoplay !== `undefined`) {
          this.swiper.autoplay.stop();
        }
      } else {
        if (this.debug) console.log("[NSS][Carousel] Not playing video!");
        this.stopAllVideos();
        if (typeof this.settings.autoplay !== `undefined`) {
          this.swiper.autoplay.start();
        }
      }
    }
  }

  stopAllVideos() {
    this.videoSlideEls.forEach((videoSlideEl) => {
      const videoEl = videoSlideEl.querySelector(`video`);
      videoEl.pause();
      videoEl.muted = true;
      videoSlideEl.setAttribute(`nss-video-playing`, false);
    });
  }

  initCarousel() {
    const carouselEl = this.querySelector(`.swiper`);
    const settings = JSON.parse(this.querySelector(`.swiper-settings`).textContent);

    // if (this.debug) console.log("[NSS][Carousel] settings:", settings);

    const presets = {
      a11y: {
        enabled: true,
      },
      navigation: {
        prevEl: ".nss-carousel-button-prev",
        nextEl: ".nss-carousel-button-next",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      grabCursor: true,
    };

    this.settings = Object.assign(presets, settings);
    if (this.debug) console.log("[NSS][Carousel] this.settings:", this.settings);

    this.swiper = new Swiper(carouselEl, this.settings);

    this.swiper.on(`reachBeginning`, this.handleReachBeginning.bind(this));
    this.swiper.on(`reachEnd`, this.handleReachEnd.bind(this));
    this.swiper.on(`slideChange`, this.handleSlideChange.bind(this));
  }

  handleSlideChange() {
    // const advisorEls = this.querySelectorAll(`nss-carousel-slide-advisor`);
    // advisorEls.forEach((advisorEl) => {
    //   advisorEl.parentElement.classList.remove(`nss-active`);
    // });
    this.swiper.update();
  }

  handleReachBeginning() {
    if (this.debug) console.log(`[NSS][Carousel] Reached beginning!`);

    const controlsEl = this.querySelector(`nss-start-end-controls`);
    const startEl = this.querySelector(`[nss-control-start]`);
    const endEl = this.querySelector(`[nss-control-end]`);
    if (controlsEl) {
      startEl.classList.add(`nss-active`);
      endEl.classList.remove(`nss-active`);
      controlsEl.setAttribute(`nss-position`, `start`);
    }
  }

  handleReachEnd() {
    if (this.debug) console.log(`[NSS][Carousel] Reached end!`);

    const controlsEl = this.querySelector(`nss-start-end-controls`);
    const startEl = this.querySelector(`[nss-control-start]`);
    const endEl = this.querySelector(`[nss-control-end]`);
    if (controlsEl) {
      startEl.classList.remove(`nss-active`);
      endEl.classList.add(`nss-active`);
      controlsEl.setAttribute(`nss-position`, `end`);
    }
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Carousel] Handle editor event, e:", e);

    switch (e.type) {
      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Carousel] slideEl:", slideEl);
        if (slideEl) {
          // const index = slideEl.getAttribute(`data-swiper-slide-index`);
          const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
          const index = slideEls.indexOf(slideEl);
          if (this.debug) console.log("[NSS][Carousel] Sliding to index:", index);
          this.swiper.slideTo(index);
        }
        break;
    }
  }
}

let elementName = `nss-carousel`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCarousel);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
